import React from "react";
import ReferralLetters from "./components/ReferralLetters";
import DashboardPrescriptions from "./components/DashboardPrescriptions"
import Consultations from "../../Consultations";

export default function History() {
  return (
    <div className="history-container" id="history-wrapper">
      <div className="tasks_header header_appointment">
        <h3 className="pharmacy_header_name">History</h3>
      </div>

      <div className="history-details">
        <DashboardPrescriptions />
        <ReferralLetters />
        <Consultations />
      </div>
    </div>
  );
}
